// import axios from "axios";

// // API Base URL
// const BASE_URL = "https://daladamaligawa.dockyardsoftware.com";

// // Action Types
// export const FETCH_LOCATIONS_REQUEST = "FETCH_LOCATIONS_REQUEST";
// export const FETCH_LOCATIONS_SUCCESS = "FETCH_LOCATIONS_SUCCESS";
// export const FETCH_LOCATIONS_FAILURE = "FETCH_LOCATIONS_FAILURE";

// export const FETCH_EMPLOYEES_BY_LOCATION_REQUEST = "FETCH_EMPLOYEES_BY_LOCATION_REQUEST";
// export const FETCH_EMPLOYEES_BY_LOCATION_SUCCESS = "FETCH_EMPLOYEES_BY_LOCATION_SUCCESS";
// export const FETCH_EMPLOYEES_BY_LOCATION_FAILURE = "FETCH_EMPLOYEES_BY_LOCATION_FAILURE";

// export const FETCH_SHIFTS_REQUEST = "FETCH_SHIFTS_REQUEST";
// export const FETCH_SHIFTS_SUCCESS = "FETCH_SHIFTS_SUCCESS";
// export const FETCH_SHIFTS_FAILURE = "FETCH_SHIFTS_FAILURE";

// export const POST_ROSTER_REQUEST = "POST_ROSTER_REQUEST";
// export const POST_ROSTER_SUCCESS = "POST_ROSTER_SUCCESS";
// export const POST_ROSTER_FAILURE = "POST_ROSTER_FAILURE";

// export const FETCH_ROSTER_DETAILS_REQUEST = "FETCH_ROSTER_DETAILS_REQUEST";
// export const FETCH_ROSTER_DETAILS_SUCCESS = "FETCH_ROSTER_DETAILS_SUCCESS";
// export const FETCH_ROSTER_DETAILS_FAILURE = "FETCH_ROSTER_DETAILS_FAILURE";

// export const POST_SCHEDULE_REQUEST = "POST_SCHEDULE_REQUEST";
// export const POST_SCHEDULE_SUCCESS = "POST_SCHEDULE_SUCCESS";
// export const POST_SCHEDULE_FAILURE = "POST_SCHEDULE_FAILURE";

// export const FETCH_ALL_ROSTER_DETAILS_REQUEST = "FETCH_ALL_ROSTER_DETAILS_REQUEST";
// export const FETCH_ALL_ROSTER_DETAILS_SUCCESS = "FETCH_ALL_ROSTER_DETAILS_SUCCESS";
// export const FETCH_ALL_ROSTER_DETAILS_FAILURE = "FETCH_ALL_ROSTER_DETAILS_FAILURE";

// // Action Creators

// // Fetch all locations from API
// export const fetchLocations = () => async (dispatch) => {
//   dispatch({ type: FETCH_LOCATIONS_REQUEST });
//   try {
//     console.log("Fetching locations from API...");
//     const response = await axios.get(
//       `${BASE_URL}/UserDetails/Locations`
//     );
    
//     console.log("Locations API Response:", response.data);
    
//     let locationsData = [];
    
//     // Handle different response formats
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       // Format: { resultSet: [...] }
//       locationsData = response.data.resultSet.map(item => ({
//         loc_code: item.locCode || item.LocCode || item.loc_code || item.code || item.Code || "",
//         loc_name: item.locName || item.LocName || item.loc_name || item.name || item.Name || "",
//         status: item.status || item.Status || "A",
//       }));
//     } else if (Array.isArray(response.data)) {
//       // Format: [...]
//       locationsData = response.data.map(item => ({
//         loc_code: item.locCode || item.LocCode || item.loc_code || item.code || item.Code || "",
//         loc_name: item.locName || item.LocName || item.loc_name || item.name || item.Name || "",
//         status: item.status || item.Status || "A",
//       }));
//     } else if (response.data && Array.isArray(response.data)) {
//       // Direct array in data
//       locationsData = response.data.map(item => ({
//         loc_code: item.locCode || item.LocCode || item.loc_code || item.code || item.Code || "",
//         loc_name: item.locName || item.LocName || item.loc_name || item.name || item.Name || "",
//         status: item.status || item.Status || "A",
//       }));
//     }
    
//     console.log("Processed locations:", locationsData);
    
//     dispatch({
//       type: FETCH_LOCATIONS_SUCCESS,
//       payload: locationsData,
//     });
    
//     return { success: true, data: locationsData };
//   } catch (error) {
//     console.error("Error fetching locations:", error);
//     console.error("Error details:", error.response?.data || error.message);
    
//     dispatch({
//       type: FETCH_LOCATIONS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Fetch employees by location
// export const fetchEmployeesByLocation = (locationCode) => async (dispatch) => {
//   dispatch({ type: FETCH_EMPLOYEES_BY_LOCATION_REQUEST });
//   try {
//     console.log(`Fetching employees for location: ${locationCode}`);
//     const response = await axios.get(
//       `${BASE_URL}/UserDetails/LocEmployee?loc=${locationCode}`
//     );
    
//     console.log(`Employees for ${locationCode}:`, response.data);
    
//     let employeesData = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       employeesData = response.data.resultSet.map(item => ({
//         service_no: item.service_no || item.sno || item.ServiceNo || item.employeeId || "",
//         Name: item.Name || item.name || item.employeeName || "",
//         Department: item.Department || item.dept || item.department || "",
//         Designation: item.Designation || item.designation || item.position || "",
//         locationCode: item.locationCode || item.locCode || locationCode,
//         status: item.status || item.Status || "A",
//       }));
//     } else if (Array.isArray(response.data)) {
//       employeesData = response.data.map(item => ({
//         service_no: item.service_no || item.sno || item.ServiceNo || item.employeeId || "",
//         Name: item.Name || item.name || item.employeeName || "",
//         Department: item.Department || item.dept || item.department || "",
//         Designation: item.Designation || item.designation || item.position || "",
//         locationCode: item.locationCode || item.locCode || locationCode,
//         status: item.status || item.Status || "A",
//       }));
//     }
    
//     console.log(`Processed employees for ${locationCode}:`, employeesData.length);
    
//     dispatch({
//       type: FETCH_EMPLOYEES_BY_LOCATION_SUCCESS,
//       payload: {
//         locationCode,
//         employees: employeesData,
//       },
//     });
    
//     return { success: true, data: employeesData };
//   } catch (error) {
//     console.error(`Error fetching employees for location ${locationCode}:`, error);
    
//     dispatch({
//       type: FETCH_EMPLOYEES_BY_LOCATION_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Fetch all shifts/schedules
// export const fetchShifts = () => async (dispatch) => {
//   dispatch({ type: FETCH_SHIFTS_REQUEST });
//   try {
//     console.log("Fetching shifts from API...");
//     const response = await axios.get(
//       `${BASE_URL}/Roster/GetSheduledetails`
//     );
    
//     console.log("Shifts API Response:", response.data);
    
//     let shiftsData = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       shiftsData = response.data.resultSet.filter(shift => shift.status === "A").map(shift => ({
//         shift_code: shift.shift_code || shift.shiftCode || shift.code || "",
//         shift_name: shift.shift_name || shift.shiftName || shift.name || "",
//         StartTime: shift.StartTime || shift.startTime || shift.start_time || "00:00",
//         EndTime: shift.EndTime || shift.endTime || shift.end_time || "00:00",
//         status: shift.status || "A",
//         Duration: shift.Duration || shift.duration || "",
//       }));
//     } else if (Array.isArray(response.data)) {
//       shiftsData = response.data.filter(shift => shift.status === "A").map(shift => ({
//         shift_code: shift.shift_code || shift.shiftCode || shift.code || "",
//         shift_name: shift.shift_name || shift.shiftName || shift.name || "",
//         StartTime: shift.StartTime || shift.startTime || shift.start_time || "00:00",
//         EndTime: shift.EndTime || shift.endTime || shift.end_time || "00:00",
//         status: shift.status || "A",
//         Duration: shift.Duration || shift.duration || "",
//       }));
//     }
    
//     console.log("Processed shifts:", shiftsData);
    
//     dispatch({
//       type: FETCH_SHIFTS_SUCCESS,
//       payload: shiftsData,
//     });
    
//     return { success: true, data: shiftsData };
//   } catch (error) {
//     console.error("Error fetching shifts:", error);
    
//     dispatch({
//       type: FETCH_SHIFTS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Post new roster assignment
// export const postRoster = (rosterData) => async (dispatch) => {
//   dispatch({ type: POST_ROSTER_REQUEST });
//   try {
//     console.log("Posting roster data:", rosterData);
    
//     // Format the data as per API requirement
//     const formattedData = Array.isArray(rosterData) ? rosterData : [rosterData];
    
//     const response = await axios.post(
//       `${BASE_URL}/Roster/PostEmployeeRoster`,
//       formattedData,
//       {
//         headers: {
//           'Content-Type': 'application/json',
//         }
//       }
//     );
    
//     console.log("Post roster response:", response.data);
    
//     dispatch({
//       type: POST_ROSTER_SUCCESS,
//       payload: response.data,
//     });
    
//     return { success: true, data: response.data };
//   } catch (error) {
//     console.error("Error posting roster:", error);
//     console.error("Error details:", error.response?.data);
    
//     dispatch({
//       type: POST_ROSTER_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { 
//       success: false, 
//       error: error.response?.data?.message || error.message,
//       details: error.response?.data 
//     };
//   }
// };

// // Post new schedule
// export const postSchedule = (scheduleData) => async (dispatch) => {
//   dispatch({ type: POST_SCHEDULE_REQUEST });
//   try {
//     console.log("Posting schedule data:", scheduleData);
    
//     // Format the data as per API requirement
//     const formattedData = Array.isArray(scheduleData) ? scheduleData : [scheduleData];
    
//     const response = await axios.post(
//       `${BASE_URL}/Roster/PostSchedule`,
//       formattedData,
//       {
//         headers: {
//           'Content-Type': 'application/json',
//         }
//       }
//     );
    
//     console.log("Post schedule response:", response.data);
    
//     dispatch({
//       type: POST_SCHEDULE_SUCCESS,
//       payload: response.data,
//     });
    
//     // Refresh shifts after adding new schedule
//     dispatch(fetchShifts());
    
//     return { success: true, data: response.data };
//   } catch (error) {
//     console.error("Error posting schedule:", error);
    
//     dispatch({
//       type: POST_SCHEDULE_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Fetch roster details
// export const fetchRosterDetails = () => async (dispatch) => {
//   dispatch({ type: FETCH_ROSTER_DETAILS_REQUEST });
//   try {
//     console.log("Fetching roster details...");
//     const response = await axios.get(
//       `${BASE_URL}/Roster/GetRosterdetails`
//     );
    
//     console.log("Roster details response:", response.data);
    
//     let rosterDetails = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       rosterDetails = response.data.resultSet;
//     } else if (Array.isArray(response.data)) {
//       rosterDetails = response.data;
//     }
    
//     dispatch({
//       type: FETCH_ROSTER_DETAILS_SUCCESS,
//       payload: rosterDetails,
//     });
    
//     return { success: true, data: rosterDetails };
//   } catch (error) {
//     console.error("Error fetching roster details:", error);
    
//     dispatch({
//       type: FETCH_ROSTER_DETAILS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Fetch all roster details with filters
// export const fetchAllRosterDetails = (filters = {}) => async (dispatch) => {
//   dispatch({ type: FETCH_ALL_ROSTER_DETAILS_REQUEST });
//   try {
//     const { loc = "", sno = "", scode = "", wdate = "" } = filters;
    
//     console.log("Fetching all roster details with filters:", filters);
    
//     const response = await axios.get(
//       `${BASE_URL}/Roster/GetAllRosterDetails?loc=${loc}&sno=${sno}&scode=${scode}&wdate=${wdate}`
//     );
    
//     console.log("All roster details response:", response.data);
    
//     let allRosterDetails = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       allRosterDetails = response.data.resultSet.map(item => ({
//         WorkDate: item.WorkDate || item.workDate || item.date || "",
//         Name: item.Name || item.name || item.employeeName || "",
//         service_no: item.service_no || item.sno || item.ServiceNo || "",
//         shift_name: item.shift_name || item.shiftName || item.shift || "",
//         StartTime: item.StartTime || item.startTime || "",
//         EndTime: item.EndTime || item.endTime || "",
//         LocName: item.LocName || item.locationName || item.location || "",
//         Department: item.Department || item.department || "",
//       }));
//     } else if (Array.isArray(response.data)) {
//       allRosterDetails = response.data.map(item => ({
//         WorkDate: item.WorkDate || item.workDate || item.date || "",
//         Name: item.Name || item.name || item.employeeName || "",
//         service_no: item.service_no || item.sno || item.ServiceNo || "",
//         shift_name: item.shift_name || item.shiftName || item.shift || "",
//         StartTime: item.StartTime || item.startTime || "",
//         EndTime: item.EndTime || item.endTime || "",
//         LocName: item.LocName || item.locationName || item.location || "",
//         Department: item.Department || item.department || "",
//       }));
//     }

    
//     console.log("Processed roster details:", allRosterDetails.length);
    
//     dispatch({
//       type: FETCH_ALL_ROSTER_DETAILS_SUCCESS,
//       payload: allRosterDetails,
//     });
    
//     return { success: true, data: allRosterDetails };
//   } catch (error) {
//     console.error("Error fetching all roster details:", error);
    
//     dispatch({
//       type: FETCH_ALL_ROSTER_DETAILS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Clear selected employees
// export const clearSelectedEmployees = () => ({
//   type: "CLEAR_SELECTED_EMPLOYEES",
// });

// // Set selected dates
// export const setSelectedDates = (dates) => ({
//   type: "SET_SELECTED_DATES",
//   payload: dates,
// });

// // Set selected shifts
// export const setSelectedShifts = (shifts) => ({
//   type: "SET_SELECTED_SHIFTS",
//   payload: shifts,
// });

// // Set selected location
// export const setSelectedLocation = (location) => ({
//   type: "SET_SELECTED_LOCATION",
//   payload: location,
// });

// // Clear all roster state
// export const clearRosterState = () => ({
//   type: "CLEAR_ROSTER_STATE",
// });

// // Test API connectivity
// export const testAPIConnectivity = () => async () => {
//   try {
//     console.log("Testing API connectivity...");
    
//     // Test locations API
//     const locationsRes = await axios.get(`${BASE_URL}/UserDetails/Locations`);
//     console.log("Locations API test:", locationsRes.status, locationsRes.data);
    
//     // Test shifts API
//     const shiftsRes = await axios.get(`${BASE_URL}/Roster/GetSheduledetails`);
//     console.log("Shifts API test:", shiftsRes.status, shiftsRes.data);
    
//     // Test roster details API
//     const rosterRes = await axios.get(`${BASE_URL}/Roster/GetAllRosterDetails`);
//     console.log("Roster API test:", rosterRes.status, rosterRes.data);
    
//     return {
//       success: true,
//       locations: locationsRes.status === 200,
//       shifts: shiftsRes.status === 200,
//       roster: rosterRes.status === 200,
//     };
//   } catch (error) {
//     console.error("API connectivity test failed:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };


// import axios from "axios";

// // API Base URL
// const BASE_URL = "https://daladamaligawa.dockyardsoftware.com";

// // Action Types
// export const FETCH_LOCATIONS_REQUEST = "FETCH_LOCATIONS_REQUEST";
// export const FETCH_LOCATIONS_SUCCESS = "FETCH_LOCATIONS_SUCCESS";
// export const FETCH_LOCATIONS_FAILURE = "FETCH_LOCATIONS_FAILURE";

// export const FETCH_EMPLOYEES_BY_LOCATION_REQUEST = "FETCH_EMPLOYEES_BY_LOCATION_REQUEST";
// export const FETCH_EMPLOYEES_BY_LOCATION_SUCCESS = "FETCH_EMPLOYEES_BY_LOCATION_SUCCESS";
// export const FETCH_EMPLOYEES_BY_LOCATION_FAILURE = "FETCH_EMPLOYEES_BY_LOCATION_FAILURE";

// export const FETCH_SHIFTS_REQUEST = "FETCH_SHIFTS_REQUEST";
// export const FETCH_SHIFTS_SUCCESS = "FETCH_SHIFTS_SUCCESS";
// export const FETCH_SHIFTS_FAILURE = "FETCH_SHIFTS_FAILURE";

// export const POST_ROSTER_REQUEST = "POST_ROSTER_REQUEST";
// export const POST_ROSTER_SUCCESS = "POST_ROSTER_SUCCESS";
// export const POST_ROSTER_FAILURE = "POST_ROSTER_FAILURE";

// export const FETCH_ROSTER_DETAILS_REQUEST = "FETCH_ROSTER_DETAILS_REQUEST";
// export const FETCH_ROSTER_DETAILS_SUCCESS = "FETCH_ROSTER_DETAILS_SUCCESS";
// export const FETCH_ROSTER_DETAILS_FAILURE = "FETCH_ROSTER_DETAILS_FAILURE";

// export const POST_SCHEDULE_REQUEST = "POST_SCHEDULE_REQUEST";
// export const POST_SCHEDULE_SUCCESS = "POST_SCHEDULE_SUCCESS";
// export const POST_SCHEDULE_FAILURE = "POST_SCHEDULE_FAILURE";

// export const FETCH_ALL_ROSTER_DETAILS_REQUEST = "FETCH_ALL_ROSTER_DETAILS_REQUEST";
// export const FETCH_ALL_ROSTER_DETAILS_SUCCESS = "FETCH_ALL_ROSTER_DETAILS_SUCCESS";
// export const FETCH_ALL_ROSTER_DETAILS_FAILURE = "FETCH_ALL_ROSTER_DETAILS_FAILURE";

// // Action Creators

// // Fetch all locations from API
// export const fetchLocations = () => async (dispatch) => {
//   dispatch({ type: FETCH_LOCATIONS_REQUEST });
//   try {
//     console.log("Fetching locations from API...");
//     const response = await axios.get(
//       `${BASE_URL}/UserDetails/Locations`
//     );
    
//     console.log("Locations API Response:", response.data);
    
//     let locationsData = [];
    
//     // Handle different response formats
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       // Format: { resultSet: [...] }
//       locationsData = response.data.resultSet.map(item => ({
//         loc_code: item.locCode || item.LocCode || item.loc_code || item.code || item.Code || "",
//         loc_name: item.locName || item.LocName || item.loc_name || item.name || item.Name || "",
//         status: item.status || item.Status || "A",
//       }));
//     } else if (Array.isArray(response.data)) {
//       // Format: [...]
//       locationsData = response.data.map(item => ({
//         loc_code: item.locCode || item.LocCode || item.loc_code || item.code || item.Code || "",
//         loc_name: item.locName || item.LocName || item.loc_name || item.name || item.Name || "",
//         status: item.status || item.Status || "A",
//       }));
//     } else if (response.data && Array.isArray(response.data)) {
//       // Direct array in data
//       locationsData = response.data.map(item => ({
//         loc_code: item.locCode || item.LocCode || item.loc_code || item.code || item.Code || "",
//         loc_name: item.locName || item.LocName || item.loc_name || item.name || item.Name || "",
//         status: item.status || item.Status || "A",
//       }));
//     }
    
//     console.log("Processed locations:", locationsData.length, "items");
    
//     dispatch({
//       type: FETCH_LOCATIONS_SUCCESS,
//       payload: locationsData,
//     });
    
//     return { success: true, data: locationsData };
//   } catch (error) {
//     console.error("Error fetching locations:", error);
//     console.error("Error details:", error.response?.data || error.message);
    
//     dispatch({
//       type: FETCH_LOCATIONS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Fetch employees by location
// export const fetchEmployeesByLocation = (locationCode) => async (dispatch) => {
//   dispatch({ type: FETCH_EMPLOYEES_BY_LOCATION_REQUEST });
//   try {
//     console.log(`Fetching employees for location: ${locationCode}`);
//     const response = await axios.get(
//       `${BASE_URL}/UserDetails/LocEmployee?loc=${locationCode}`
//     );
    
//     console.log(`Employees for ${locationCode}:`, response.data);
    
//     let employeesData = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       employeesData = response.data.resultSet.map(item => ({
//         service_no: item.service_no || item.sno || item.ServiceNo || item.employeeId || "",
//         Name: item.Name || item.name || item.employeeName || "",
//         Department: item.Department || item.dept || item.department || "",
//         Designation: item.Designation || item.designation || item.position || "",
//         locationCode: item.locationCode || item.locCode || locationCode,
//         status: item.status || item.Status || "A",
//       }));
//     } else if (Array.isArray(response.data)) {
//       employeesData = response.data.map(item => ({
//         service_no: item.service_no || item.sno || item.ServiceNo || item.employeeId || "",
//         Name: item.Name || item.name || item.employeeName || "",
//         Department: item.Department || item.dept || item.department || "",
//         Designation: item.Designation || item.designation || item.position || "",
//         locationCode: item.locationCode || item.locCode || locationCode,
//         status: item.status || item.Status || "A",
//       }));
//     }
    
//     console.log(`Processed employees for ${locationCode}:`, employeesData.length);
    
//     dispatch({
//       type: FETCH_EMPLOYEES_BY_LOCATION_SUCCESS,
//       payload: {
//         locationCode,
//         employees: employeesData,
//       },
//     });
    
//     return { success: true, data: employeesData };
//   } catch (error) {
//     console.error(`Error fetching employees for location ${locationCode}:`, error);
    
//     dispatch({
//       type: FETCH_EMPLOYEES_BY_LOCATION_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Fetch all shifts/schedules
// export const fetchShifts = () => async (dispatch) => {
//   dispatch({ type: FETCH_SHIFTS_REQUEST });
//   try {
//     console.log("Fetching shifts from API...");
//     const response = await axios.get(
//       `${BASE_URL}/Roster/GetSheduledetails`
//     );
    
//     console.log("Shifts API Response:", response.data);
    
//     let shiftsData = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       shiftsData = response.data.resultSet.filter(shift => shift.status === "A").map(shift => ({
//         shift_code: shift.shift_code || shift.shiftCode || shift.code || "",
//         shift_name: shift.shift_name || shift.shiftName || shift.name || "",
//         StartTime: shift.StartTime || shift.startTime || shift.start_time || "00:00",
//         EndTime: shift.EndTime || shift.endTime || shift.end_time || "00:00",
//         status: shift.status || "A",
//         Duration: shift.Duration || shift.duration || "",
//       }));
//     } else if (Array.isArray(response.data)) {
//       shiftsData = response.data.filter(shift => shift.status === "A").map(shift => ({
//         shift_code: shift.shift_code || shift.shiftCode || shift.code || "",
//         shift_name: shift.shift_name || shift.shiftName || shift.name || "",
//         StartTime: shift.StartTime || shift.startTime || shift.start_time || "00:00",
//         EndTime: shift.EndTime || shift.endTime || shift.end_time || "00:00",
//         status: shift.status || "A",
//         Duration: shift.Duration || shift.duration || "",
//       }));
//     }
    
//     console.log("Processed shifts:", shiftsData.length, "items");
    
//     dispatch({
//       type: FETCH_SHIFTS_SUCCESS,
//       payload: shiftsData,
//     });
    
//     return { success: true, data: shiftsData };
//   } catch (error) {
//     console.error("Error fetching shifts:", error);
    
//     dispatch({
//       type: FETCH_SHIFTS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Post new roster assignment - FIXED VERSION
// export const postRoster = (rosterData) => async (dispatch) => {
//   dispatch({ type: POST_ROSTER_REQUEST });
//   try {
//     console.log("Posting roster data:", rosterData);
    
//     // Format the data as per API requirement
//     const formattedData = Array.isArray(rosterData) ? rosterData : [rosterData];
    
//     console.log("Formatted data for API:", formattedData);
    
//     const response = await axios.post(
//       `${BASE_URL}/Roster/PostEmployeeRoster`,
//       formattedData,
//       {
//         headers: {
//           'Content-Type': 'application/json',
//         }
//       }
//     );
    
//     console.log("Post roster response:", response.data);
    
//     if (response.data && response.data.statusCode === 200) {
//       dispatch({
//         type: POST_ROSTER_SUCCESS,
//         payload: response.data,
//       });
      
//       // Refresh data after successful post
//       setTimeout(() => {
//         dispatch(fetchAllRosterDetails({}));
//       }, 500);
      
//       return { 
//         success: true, 
//         data: response.data,
//         message: "Roster assigned successfully!" 
//       };
//     } else {
//       throw new Error(response.data?.message || "Failed to assign roster");
//     }
//   } catch (error) {
//     console.error("Error posting roster:", error);
//     console.error("Error details:", error.response?.data);
    
//     let errorMessage = "Failed to assign roster";
//     if (error.response?.data?.message) {
//       errorMessage = error.response.data.message;
//     } else if (error.message) {
//       errorMessage = error.message;
//     }
    
//     dispatch({
//       type: POST_ROSTER_FAILURE,
//       payload: errorMessage,
//     });
    
//     return { 
//       success: false, 
//       error: errorMessage,
//       details: error.response?.data 
//     };
//   }
// };

// // Post new schedule
// export const postSchedule = (scheduleData) => async (dispatch) => {
//   dispatch({ type: POST_SCHEDULE_REQUEST });
//   try {
//     console.log("Posting schedule data:", scheduleData);
    
//     // Format the data as per API requirement
//     const formattedData = Array.isArray(scheduleData) ? scheduleData : [scheduleData];
    
//     const response = await axios.post(
//       `${BASE_URL}/Roster/PostSchedule`,
//       formattedData,
//       {
//         headers: {
//           'Content-Type': 'application/json',
//         }
//       }
//     );
    
//     console.log("Post schedule response:", response.data);
    
//     if (response.data && response.data.statusCode === 200) {
//       dispatch({
//         type: POST_SCHEDULE_SUCCESS,
//         payload: response.data,
//       });
      
//       // Refresh shifts after adding new schedule
//       dispatch(fetchShifts());
      
//       return { 
//         success: true, 
//         data: response.data,
//         message: "Schedule added successfully!" 
//       };
//     } else {
//       throw new Error(response.data?.message || "Failed to add schedule");
//     }
//   } catch (error) {
//     console.error("Error posting schedule:", error);
    
//     dispatch({
//       type: POST_SCHEDULE_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { 
//       success: false, 
//       error: error.response?.data?.message || error.message 
//     };
//   }
// };

// // Fetch roster details
// export const fetchRosterDetails = () => async (dispatch) => {
//   dispatch({ type: FETCH_ROSTER_DETAILS_REQUEST });
//   try {
//     console.log("Fetching roster details...");
//     const response = await axios.get(
//       `${BASE_URL}/Roster/GetRosterdetails`
//     );
    
//     console.log("Roster details response:", response.data);
    
//     let rosterDetails = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       rosterDetails = response.data.resultSet;
//     } else if (Array.isArray(response.data)) {
//       rosterDetails = response.data;
//     }
    
//     console.log("Processed roster details:", rosterDetails.length, "items");
    
//     dispatch({
//       type: FETCH_ROSTER_DETAILS_SUCCESS,
//       payload: rosterDetails,
//     });
    
//     return { success: true, data: rosterDetails };
//   } catch (error) {
//     console.error("Error fetching roster details:", error);
    
//     dispatch({
//       type: FETCH_ROSTER_DETAILS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Fetch all roster details with filters - FIXED VERSION
// export const fetchAllRosterDetails = (filters = {}) => async (dispatch) => {
//   dispatch({ type: FETCH_ALL_ROSTER_DETAILS_REQUEST });
//   try {
//     const { loc = "", sno = "", scode = "", wdate = "" } = filters;
    
//     console.log("Fetching all roster details with filters:", filters);
    
//     const response = await axios.get(
//       `${BASE_URL}/Roster/GetAllRosterDetails?loc=${loc}&sno=${sno}&scode=${scode}&wdate=${wdate}`
//     );
    
//     console.log("All roster details API response:", response.data);
    
//     let allRosterDetails = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       // Based on your API response format
//       allRosterDetails = response.data.resultSet.map(item => ({
//         WorkDate: item.wDate || item.WorkDate || item.date || "",
//         Name: item.RName || item.Name || item.name || item.employeeName || "",
//         service_no: item.sNo || item.service_no || item.sno || item.ServiceNo || "",
//         shift_name: item.shiftName || item.shift_name || item.shift || "",
//         shift_code: item.shiftCode || item.shift_code || "",
//         location: item.location || item.LocName || item.locationName || "",
//         // Include original fields for debugging
//         original: item
//       }));
//     } else if (Array.isArray(response.data)) {
//       allRosterDetails = response.data.map(item => ({
//         WorkDate: item.wDate || item.WorkDate || item.date || "",
//         Name: item.RName || item.Name || item.name || item.employeeName || "",
//         service_no: item.sNo || item.service_no || item.sno || item.ServiceNo || "",
//         shift_name: item.shiftName || item.shift_name || item.shift || "",
//         shift_code: item.shiftCode || item.shift_code || "",
//         location: item.location || item.LocName || item.locationName || "",
//       }));
//     } else if (response.data && Array.isArray(response.data)) {
//       allRosterDetails = response.data.map(item => ({
//         WorkDate: item.wDate || item.WorkDate || item.date || "",
//         Name: item.RName || item.Name || item.name || item.employeeName || "",
//         service_no: item.sNo || item.service_no || item.sno || item.ServiceNo || "",
//         shift_name: item.shiftName || item.shift_name || item.shift || "",
//         shift_code: item.shiftCode || item.shift_code || "",
//         location: item.location || item.LocName || item.locationName || "",
//       }));
//     }
    
//     console.log("Processed roster details:", allRosterDetails.length, "items");
//     if (allRosterDetails.length > 0) {
//       console.log("First roster item:", allRosterDetails[0]);
//     }
    
//     dispatch({
//       type: FETCH_ALL_ROSTER_DETAILS_SUCCESS,
//       payload: allRosterDetails,
//     });
    
//     return { success: true, data: allRosterDetails };
//   } catch (error) {
//     console.error("Error fetching all roster details:", error);
    
//     dispatch({
//       type: FETCH_ALL_ROSTER_DETAILS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Clear selected employees
// export const clearSelectedEmployees = () => ({
//   type: "CLEAR_SELECTED_EMPLOYEES",
// });

// // Set selected dates
// export const setSelectedDates = (dates) => ({
//   type: "SET_SELECTED_DATES",
//   payload: dates,
// });

// // Set selected shifts
// export const setSelectedShifts = (shifts) => ({
//   type: "SET_SELECTED_SHIFTS",
//   payload: shifts,
// });

// // Set selected location
// export const setSelectedLocation = (location) => ({
//   type: "SET_SELECTED_LOCATION",
//   payload: location,
// });

// // Clear all roster state
// export const clearRosterState = () => ({
//   type: "CLEAR_ROSTER_STATE",
// });

// // Reset posting state
// export const resetPostRosterState = () => ({
//   type: "RESET_POST_ROSTER_STATE",
// });

// // Test API connectivity
// export const testAPIConnectivity = () => async () => {
//   try {
//     console.log("Testing API connectivity...");
    
//     // Test locations API
//     const locationsRes = await axios.get(`${BASE_URL}/UserDetails/Locations`);
//     console.log("Locations API test:", locationsRes.status, locationsRes.data);
    
//     // Test shifts API
//     const shiftsRes = await axios.get(`${BASE_URL}/Roster/GetSheduledetails`);
//     console.log("Shifts API test:", shiftsRes.status, shiftsRes.data);
    
//     // Test roster details API
//     const rosterRes = await axios.get(`${BASE_URL}/Roster/GetAllRosterDetails`);
//     console.log("Roster API test:", rosterRes.status, rosterRes.data);
    
//     return {
//       success: true,
//       locations: locationsRes.status === 200,
//       shifts: shiftsRes.status === 200,
//       roster: rosterRes.status === 200,
//       message: "All API endpoints are accessible!"
//     };
//   } catch (error) {
//     console.error("API connectivity test failed:", error);
//     return {
//       success: false,
//       error: error.message,
//       message: "API connectivity test failed. Check console for details."
//     };
//   }
// };


// import axios from "axios";

// // API Base URL
// const BASE_URL = "https://daladamaligawa.dockyardsoftware.com";

// // Action Types
// export const FETCH_LOCATIONS_REQUEST = "FETCH_LOCATIONS_REQUEST";
// export const FETCH_LOCATIONS_SUCCESS = "FETCH_LOCATIONS_SUCCESS";
// export const FETCH_LOCATIONS_FAILURE = "FETCH_LOCATIONS_FAILURE";

// export const FETCH_EMPLOYEES_BY_LOCATION_REQUEST = "FETCH_EMPLOYEES_BY_LOCATION_REQUEST";
// export const FETCH_EMPLOYEES_BY_LOCATION_SUCCESS = "FETCH_EMPLOYEES_BY_LOCATION_SUCCESS";
// export const FETCH_EMPLOYEES_BY_LOCATION_FAILURE = "FETCH_EMPLOYEES_BY_LOCATION_FAILURE";

// export const FETCH_SHIFTS_REQUEST = "FETCH_SHIFTS_REQUEST";
// export const FETCH_SHIFTS_SUCCESS = "FETCH_SHIFTS_SUCCESS";
// export const FETCH_SHIFTS_FAILURE = "FETCH_SHIFTS_FAILURE";

// export const POST_ROSTER_REQUEST = "POST_ROSTER_REQUEST";
// export const POST_ROSTER_SUCCESS = "POST_ROSTER_SUCCESS";
// export const POST_ROSTER_FAILURE = "POST_ROSTER_FAILURE";

// export const FETCH_ROSTER_DETAILS_REQUEST = "FETCH_ROSTER_DETAILS_REQUEST";
// export const FETCH_ROSTER_DETAILS_SUCCESS = "FETCH_ROSTER_DETAILS_SUCCESS";
// export const FETCH_ROSTER_DETAILS_FAILURE = "FETCH_ROSTER_DETAILS_FAILURE";

// export const POST_SCHEDULE_REQUEST = "POST_SCHEDULE_REQUEST";
// export const POST_SCHEDULE_SUCCESS = "POST_SCHEDULE_SUCCESS";
// export const POST_SCHEDULE_FAILURE = "POST_SCHEDULE_FAILURE";

// export const FETCH_ALL_ROSTER_DETAILS_REQUEST = "FETCH_ALL_ROSTER_DETAILS_REQUEST";
// export const FETCH_ALL_ROSTER_DETAILS_SUCCESS = "FETCH_ALL_ROSTER_DETAILS_SUCCESS";
// export const FETCH_ALL_ROSTER_DETAILS_FAILURE = "FETCH_ALL_ROSTER_DETAILS_FAILURE";

// // Action Creators

// // Fetch all locations from API
// export const fetchLocations = () => async (dispatch) => {
//   dispatch({ type: FETCH_LOCATIONS_REQUEST });
//   try {
//     console.log("Fetching locations from API...");
//     const response = await axios.get(
//       `${BASE_URL}/UserDetails/Locations`
//     );
    
//     console.log("Locations API Response:", response.data);
    
//     let locationsData = [];
    
//     // Handle different response formats
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       // Format: { resultSet: [...] }
//       locationsData = response.data.resultSet.map(item => ({
//         loc_code: item.locCode || item.LocCode || item.loc_code || item.code || item.Code || "",
//         loc_name: item.locName || item.LocName || item.loc_name || item.name || item.Name || "",
//         status: item.status || item.Status || "A",
//       }));
//     } else if (Array.isArray(response.data)) {
//       // Format: [...]
//       locationsData = response.data.map(item => ({
//         loc_code: item.locCode || item.LocCode || item.loc_code || item.code || item.Code || "",
//         loc_name: item.locName || item.LocName || item.loc_name || item.name || item.Name || "",
//         status: item.status || item.Status || "A",
//       }));
//     } else if (response.data && Array.isArray(response.data)) {
//       // Direct array in data
//       locationsData = response.data.map(item => ({
//         loc_code: item.locCode || item.LocCode || item.loc_code || item.code || item.Code || "",
//         loc_name: item.locName || item.LocName || item.loc_name || item.name || item.Name || "",
//         status: item.status || item.Status || "A",
//       }));
//     }
    
//     console.log("Processed locations:", locationsData);
    
//     dispatch({
//       type: FETCH_LOCATIONS_SUCCESS,
//       payload: locationsData,
//     });
    
//     return { success: true, data: locationsData };
//   } catch (error) {
//     console.error("Error fetching locations:", error);
//     console.error("Error details:", error.response?.data || error.message);
    
//     dispatch({
//       type: FETCH_LOCATIONS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Fetch employees by location
// export const fetchEmployeesByLocation = (locationCode) => async (dispatch) => {
//   dispatch({ type: FETCH_EMPLOYEES_BY_LOCATION_REQUEST });
//   try {
//     console.log(`Fetching employees for location: ${locationCode}`);
//     const response = await axios.get(
//       `${BASE_URL}/UserDetails/LocEmployee?loc=${locationCode}`
//     );
    
//     console.log(`Employees for ${locationCode}:`, response.data);
    
//     let employeesData = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       employeesData = response.data.resultSet.map(item => ({
//         service_no: item.service_no || item.sno || item.ServiceNo || item.employeeId || "",
//         Name: item.Name || item.name || item.employeeName || "",
//         Department: item.Department || item.dept || item.department || "",
//         Designation: item.Designation || item.designation || item.position || "",
//         locationCode: item.locationCode || item.locCode || locationCode,
//         status: item.status || item.Status || "A",
//       }));
//     } else if (Array.isArray(response.data)) {
//       employeesData = response.data.map(item => ({
//         service_no: item.service_no || item.sno || item.ServiceNo || item.employeeId || "",
//         Name: item.Name || item.name || item.employeeName || "",
//         Department: item.Department || item.dept || item.department || "",
//         Designation: item.Designation || item.designation || item.position || "",
//         locationCode: item.locationCode || item.locCode || locationCode,
//         status: item.status || item.Status || "A",
//       }));
//     }
    
//     console.log(`Processed employees for ${locationCode}:`, employeesData.length);
    
//     dispatch({
//       type: FETCH_EMPLOYEES_BY_LOCATION_SUCCESS,
//       payload: {
//         locationCode,
//         employees: employeesData,
//       },
//     });
    
//     return { success: true, data: employeesData };
//   } catch (error) {
//     console.error(`Error fetching employees for location ${locationCode}:`, error);
    
//     dispatch({
//       type: FETCH_EMPLOYEES_BY_LOCATION_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Fetch all shifts/schedules
// export const fetchShifts = () => async (dispatch) => {
//   dispatch({ type: FETCH_SHIFTS_REQUEST });
//   try {
//     console.log("Fetching shifts from API...");
//     const response = await axios.get(
//       `${BASE_URL}/Roster/GetSheduledetails`
//     );
    
//     console.log("Shifts API Response:", response.data);
    
//     let shiftsData = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       shiftsData = response.data.resultSet.filter(shift => shift.status === "A").map(shift => ({
//         shift_code: shift.shift_code || shift.shiftCode || shift.code || "",
//         shift_name: shift.shift_name || shift.shiftName || shift.name || "",
//         StartTime: shift.StartTime || shift.startTime || shift.start_time || "00:00",
//         EndTime: shift.EndTime || shift.endTime || shift.end_time || "00:00",
//         status: shift.status || "A",
//         Duration: shift.Duration || shift.duration || "",
//       }));
//     } else if (Array.isArray(response.data)) {
//       shiftsData = response.data.filter(shift => shift.status === "A").map(shift => ({
//         shift_code: shift.shift_code || shift.shiftCode || shift.code || "",
//         shift_name: shift.shift_name || shift.shiftName || shift.name || "",
//         StartTime: shift.StartTime || shift.startTime || shift.start_time || "00:00",
//         EndTime: shift.EndTime || shift.endTime || shift.end_time || "00:00",
//         status: shift.status || "A",
//         Duration: shift.Duration || shift.duration || "",
//       }));
//     }
    
//     console.log("Processed shifts:", shiftsData);
    
//     dispatch({
//       type: FETCH_SHIFTS_SUCCESS,
//       payload: shiftsData,
//     });
    
//     return { success: true, data: shiftsData };
//   } catch (error) {
//     console.error("Error fetching shifts:", error);
    
//     dispatch({
//       type: FETCH_SHIFTS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Post new roster assignment
// export const postRoster = (rosterData) => async (dispatch) => {
//   dispatch({ type: POST_ROSTER_REQUEST });
//   try {
//     console.log("Posting roster data:", rosterData);
    
//     // Format the data as per API requirement
//     const formattedData = Array.isArray(rosterData) ? rosterData : [rosterData];
    
//     const response = await axios.post(
//       `${BASE_URL}/Roster/PostEmployeeRoster`,
//       formattedData,
//       {
//         headers: {
//           'Content-Type': 'application/json',
//         }
//       }
//     );
    
//     console.log("Post roster response:", response.data);
    
//     dispatch({
//       type: POST_ROSTER_SUCCESS,
//       payload: response.data,
//     });
    
//     return { success: true, data: response.data };
//   } catch (error) {
//     console.error("Error posting roster:", error);
//     console.error("Error details:", error.response?.data);
    
//     dispatch({
//       type: POST_ROSTER_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { 
//       success: false, 
//       error: error.response?.data?.message || error.message,
//       details: error.response?.data 
//     };
//   }
// };

// // Post new schedule
// export const postSchedule = (scheduleData) => async (dispatch) => {
//   dispatch({ type: POST_SCHEDULE_REQUEST });
//   try {
//     console.log("Posting schedule data:", scheduleData);
    
//     // Format the data as per API requirement
//     const formattedData = Array.isArray(scheduleData) ? scheduleData : [scheduleData];
    
//     const response = await axios.post(
//       `${BASE_URL}/Roster/PostSchedule`,
//       formattedData,
//       {
//         headers: {
//           'Content-Type': 'application/json',
//         }
//       }
//     );
    
//     console.log("Post schedule response:", response.data);
    
//     dispatch({
//       type: POST_SCHEDULE_SUCCESS,
//       payload: response.data,
//     });
    
//     // Refresh shifts after adding new schedule
//     dispatch(fetchShifts());
    
//     return { success: true, data: response.data };
//   } catch (error) {
//     console.error("Error posting schedule:", error);
    
//     dispatch({
//       type: POST_SCHEDULE_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Fetch roster details
// export const fetchRosterDetails = () => async (dispatch) => {
//   dispatch({ type: FETCH_ROSTER_DETAILS_REQUEST });
//   try {
//     console.log("Fetching roster details...");
//     const response = await axios.get(
//       `${BASE_URL}/Roster/GetRosterdetails`
//     );
    
//     console.log("Roster details response:", response.data);
    
//     let rosterDetails = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       rosterDetails = response.data.resultSet;
//     } else if (Array.isArray(response.data)) {
//       rosterDetails = response.data;
//     }
    
//     dispatch({
//       type: FETCH_ROSTER_DETAILS_SUCCESS,
//       payload: rosterDetails,
//     });
    
//     return { success: true, data: rosterDetails };
//   } catch (error) {
//     console.error("Error fetching roster details:", error);
    
//     dispatch({
//       type: FETCH_ROSTER_DETAILS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Fetch all roster details with filters
// export const fetchAllRosterDetails = (filters = {}) => async (dispatch) => {
//   dispatch({ type: FETCH_ALL_ROSTER_DETAILS_REQUEST });
//   try {
//     const { loc = "", sno = "", scode = "", wdate = "" } = filters;
    
//     console.log("Fetching all roster details with filters:", filters);
    
//     const response = await axios.get(
//       `${BASE_URL}/Roster/GetAllRosterDetails?loc=${loc}&sno=${sno}&scode=${scode}&wdate=${wdate}`
//     );
    
//     console.log("All roster details response:", response.data);
    
//     let allRosterDetails = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       allRosterDetails = response.data.resultSet.map(item => ({
//         WorkDate: item.WorkDate || item.workDate || item.date || "",
//         Name: item.Name || item.name || item.employeeName || "",
//         service_no: item.service_no || item.sno || item.ServiceNo || "",
//         shift_name: item.shift_name || item.shiftName || item.shift || "",
//         StartTime: item.StartTime || item.startTime || "",
//         EndTime: item.EndTime || item.endTime || "",
//         LocName: item.LocName || item.locationName || item.location || "",
//         Department: item.Department || item.department || "",
//       }));
//     } else if (Array.isArray(response.data)) {
//       allRosterDetails = response.data.map(item => ({
//         WorkDate: item.WorkDate || item.workDate || item.date || "",
//         Name: item.Name || item.name || item.employeeName || "",
//         service_no: item.service_no || item.sno || item.ServiceNo || "",
//         shift_name: item.shift_name || item.shiftName || item.shift || "",
//         StartTime: item.StartTime || item.startTime || "",
//         EndTime: item.EndTime || item.endTime || "",
//         LocName: item.LocName || item.locationName || item.location || "",
//         Department: item.Department || item.department || "",
//       }));
//     }

    
//     console.log("Processed roster details:", allRosterDetails.length);
    
//     dispatch({
//       type: FETCH_ALL_ROSTER_DETAILS_SUCCESS,
//       payload: allRosterDetails,
//     });
    
//     return { success: true, data: allRosterDetails };
//   } catch (error) {
//     console.error("Error fetching all roster details:", error);
    
//     dispatch({
//       type: FETCH_ALL_ROSTER_DETAILS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Clear selected employees
// export const clearSelectedEmployees = () => ({
//   type: "CLEAR_SELECTED_EMPLOYEES",
// });

// // Set selected dates
// export const setSelectedDates = (dates) => ({
//   type: "SET_SELECTED_DATES",
//   payload: dates,
// });

// // Set selected shifts
// export const setSelectedShifts = (shifts) => ({
//   type: "SET_SELECTED_SHIFTS",
//   payload: shifts,
// });

// // Set selected location
// export const setSelectedLocation = (location) => ({
//   type: "SET_SELECTED_LOCATION",
//   payload: location,
// });

// // Clear all roster state
// export const clearRosterState = () => ({
//   type: "CLEAR_ROSTER_STATE",
// });

// // Test API connectivity
// export const testAPIConnectivity = () => async () => {
//   try {
//     console.log("Testing API connectivity...");
    
//     // Test locations API
//     const locationsRes = await axios.get(`${BASE_URL}/UserDetails/Locations`);
//     console.log("Locations API test:", locationsRes.status, locationsRes.data);
    
//     // Test shifts API
//     const shiftsRes = await axios.get(`${BASE_URL}/Roster/GetSheduledetails`);
//     console.log("Shifts API test:", shiftsRes.status, shiftsRes.data);
    
//     // Test roster details API
//     const rosterRes = await axios.get(`${BASE_URL}/Roster/GetAllRosterDetails`);
//     console.log("Roster API test:", rosterRes.status, rosterRes.data);
    
//     return {
//       success: true,
//       locations: locationsRes.status === 200,
//       shifts: shiftsRes.status === 200,
//       roster: rosterRes.status === 200,
//     };
//   } catch (error) {
//     console.error("API connectivity test failed:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };


// import axios from "axios";

// // API Base URL
// const BASE_URL = "https://daladamaligawa.dockyardsoftware.com";

// // Action Types
// export const FETCH_LOCATIONS_REQUEST = "FETCH_LOCATIONS_REQUEST";
// export const FETCH_LOCATIONS_SUCCESS = "FETCH_LOCATIONS_SUCCESS";
// export const FETCH_LOCATIONS_FAILURE = "FETCH_LOCATIONS_FAILURE";

// export const FETCH_EMPLOYEES_BY_LOCATION_REQUEST = "FETCH_EMPLOYEES_BY_LOCATION_REQUEST";
// export const FETCH_EMPLOYEES_BY_LOCATION_SUCCESS = "FETCH_EMPLOYEES_BY_LOCATION_SUCCESS";
// export const FETCH_EMPLOYEES_BY_LOCATION_FAILURE = "FETCH_EMPLOYEES_BY_LOCATION_FAILURE";

// export const FETCH_SHIFTS_REQUEST = "FETCH_SHIFTS_REQUEST";
// export const FETCH_SHIFTS_SUCCESS = "FETCH_SHIFTS_SUCCESS";
// export const FETCH_SHIFTS_FAILURE = "FETCH_SHIFTS_FAILURE";

// export const POST_ROSTER_REQUEST = "POST_ROSTER_REQUEST";
// export const POST_ROSTER_SUCCESS = "POST_ROSTER_SUCCESS";
// export const POST_ROSTER_FAILURE = "POST_ROSTER_FAILURE";

// export const FETCH_ROSTER_DETAILS_REQUEST = "FETCH_ROSTER_DETAILS_REQUEST";
// export const FETCH_ROSTER_DETAILS_SUCCESS = "FETCH_ROSTER_DETAILS_SUCCESS";
// export const FETCH_ROSTER_DETAILS_FAILURE = "FETCH_ROSTER_DETAILS_FAILURE";

// export const POST_SCHEDULE_REQUEST = "POST_SCHEDULE_REQUEST";
// export const POST_SCHEDULE_SUCCESS = "POST_SCHEDULE_SUCCESS";
// export const POST_SCHEDULE_FAILURE = "POST_SCHEDULE_FAILURE";

// export const FETCH_ALL_ROSTER_DETAILS_REQUEST = "FETCH_ALL_ROSTER_DETAILS_REQUEST";
// export const FETCH_ALL_ROSTER_DETAILS_SUCCESS = "FETCH_ALL_ROSTER_DETAILS_SUCCESS";
// export const FETCH_ALL_ROSTER_DETAILS_FAILURE = "FETCH_ALL_ROSTER_DETAILS_FAILURE";

// // Action Creators

// // Fetch all locations from API
// export const fetchLocations = () => async (dispatch) => {
//   dispatch({ type: FETCH_LOCATIONS_REQUEST });
//   try {
//     console.log("Fetching locations from API...");
//     const response = await axios.get(
//       `${BASE_URL}/UserDetails/Locations`
//     );
    
//     console.log("Locations API Response:", response.data);
    
//     let locationsData = [];
    
//     // Handle different response formats
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       // Format: { resultSet: [...] }
//       locationsData = response.data.resultSet.map(item => ({
//         loc_code: item.locCode || item.LocCode || item.loc_code || item.code || item.Code || "",
//         loc_name: item.locName || item.LocName || item.loc_name || item.name || item.Name || "",
//         status: item.status || item.Status || "A",
//       }));
//     } else if (Array.isArray(response.data)) {
//       // Format: [...]
//       locationsData = response.data.map(item => ({
//         loc_code: item.locCode || item.LocCode || item.loc_code || item.code || item.Code || "",
//         loc_name: item.locName || item.LocName || item.loc_name || item.name || item.Name || "",
//         status: item.status || item.Status || "A",
//       }));
//     } else if (response.data && Array.isArray(response.data)) {
//       // Direct array in data
//       locationsData = response.data.map(item => ({
//         loc_code: item.locCode || item.LocCode || item.loc_code || item.code || item.Code || "",
//         loc_name: item.locName || item.LocName || item.loc_name || item.name || item.Name || "",
//         status: item.status || item.Status || "A",
//       }));
//     }
    
//     console.log("Processed locations:", locationsData.length, "items");
    
//     dispatch({
//       type: FETCH_LOCATIONS_SUCCESS,
//       payload: locationsData,
//     });
    
//     return { success: true, data: locationsData };
//   } catch (error) {
//     console.error("Error fetching locations:", error);
//     console.error("Error details:", error.response?.data || error.message);
    
//     dispatch({
//       type: FETCH_LOCATIONS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Fetch employees by location
// export const fetchEmployeesByLocation = (locationCode) => async (dispatch) => {
//   dispatch({ type: FETCH_EMPLOYEES_BY_LOCATION_REQUEST });
//   try {
//     console.log(`Fetching employees for location: ${locationCode}`);
//     const response = await axios.get(
//       `${BASE_URL}/UserDetails/LocEmployee?loc=${locationCode}`
//     );
    
//     console.log(`Employees for ${locationCode}:`, response.data);
    
//     let employeesData = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       employeesData = response.data.resultSet.map(item => ({
//         service_no: item.service_no || item.sno || item.ServiceNo || item.employeeId || "",
//         Name: item.Name || item.name || item.employeeName || "",
//         Department: item.Department || item.dept || item.department || "",
//         Designation: item.Designation || item.designation || item.position || "",
//         locationCode: item.locationCode || item.locCode || locationCode,
//         status: item.status || item.Status || "A",
//       }));
//     } else if (Array.isArray(response.data)) {
//       employeesData = response.data.map(item => ({
//         service_no: item.service_no || item.sno || item.ServiceNo || item.employeeId || "",
//         Name: item.Name || item.name || item.employeeName || "",
//         Department: item.Department || item.dept || item.department || "",
//         Designation: item.Designation || item.designation || item.position || "",
//         locationCode: item.locationCode || item.locCode || locationCode,
//         status: item.status || item.Status || "A",
//       }));
//     }
    
//     console.log(`Processed employees for ${locationCode}:`, employeesData.length);
    
//     dispatch({
//       type: FETCH_EMPLOYEES_BY_LOCATION_SUCCESS,
//       payload: {
//         locationCode,
//         employees: employeesData,
//       },
//     });
    
//     return { success: true, data: employeesData };
//   } catch (error) {
//     console.error(`Error fetching employees for location ${locationCode}:`, error);
    
//     dispatch({
//       type: FETCH_EMPLOYEES_BY_LOCATION_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Fetch all shifts/schedules
// export const fetchShifts = () => async (dispatch) => {
//   dispatch({ type: FETCH_SHIFTS_REQUEST });
//   try {
//     console.log("Fetching shifts from API...");
//     const response = await axios.get(
//       `${BASE_URL}/Roster/GetSheduledetails`
//     );
    
//     console.log("Shifts API Response:", response.data);
    
//     let shiftsData = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       shiftsData = response.data.resultSet.filter(shift => shift.status === "A").map(shift => ({
//         shift_code: shift.shift_code || shift.shiftCode || shift.code || "",
//         shift_name: shift.shift_name || shift.shiftName || shift.name || "",
//         StartTime: shift.StartTime || shift.startTime || shift.start_time || "00:00",
//         EndTime: shift.EndTime || shift.endTime || shift.end_time || "00:00",
//         status: shift.status || "A",
//         Duration: shift.Duration || shift.duration || "",
//       }));
//     } else if (Array.isArray(response.data)) {
//       shiftsData = response.data.filter(shift => shift.status === "A").map(shift => ({
//         shift_code: shift.shift_code || shift.shiftCode || shift.code || "",
//         shift_name: shift.shift_name || shift.shiftName || shift.name || "",
//         StartTime: shift.StartTime || shift.startTime || shift.start_time || "00:00",
//         EndTime: shift.EndTime || shift.endTime || shift.end_time || "00:00",
//         status: shift.status || "A",
//         Duration: shift.Duration || shift.duration || "",
//       }));
//     }
    
//     console.log("Processed shifts:", shiftsData.length, "items");
    
//     dispatch({
//       type: FETCH_SHIFTS_SUCCESS,
//       payload: shiftsData,
//     });
    
//     return { success: true, data: shiftsData };
//   } catch (error) {
//     console.error("Error fetching shifts:", error);
    
//     dispatch({
//       type: FETCH_SHIFTS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Post new roster assignment - FIXED VERSION
// export const postRoster = (rosterData) => async (dispatch) => {
//   dispatch({ type: POST_ROSTER_REQUEST });
//   try {
//     console.log("Posting roster data:", rosterData);
    
//     // Format the data as per API requirement
//     const formattedData = Array.isArray(rosterData) ? rosterData : [rosterData];
    
//     console.log("Formatted data for API:", JSON.stringify(formattedData));
//     console.log("Sending POST request to:", `${BASE_URL}/Roster/PostEmployeeRoster`);
    
//     const response = await axios.post(
//       `${BASE_URL}/Roster/PostEmployeeRoster`,
//       formattedData,
//       {
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         timeout: 30000, // 30 second timeout
//       }
//     );
    
//     console.log("Post roster response status:", response.status);
//     console.log("Post roster response data:", response.data);
    
//     // Check for success - handle different response formats
//     if (response.status === 200 || response.data?.statusCode === 200) {
//       dispatch({
//         type: POST_ROSTER_SUCCESS,
//         payload: response.data,
//       });
      
//       return { 
//         success: true, 
//         data: response.data,
//         message: "Roster assigned successfully!" 
//       };
//     } else {
//       throw new Error(response.data?.message || "Failed to assign roster");
//     }
//   } catch (error) {
//     console.error("Error posting roster:", error);
//     console.error("Error details:", error.response?.data);
    
//     let errorMessage = "Failed to assign roster";
    
//     if (error.code === 'ECONNABORTED') {
//       errorMessage = "Request timed out. Please try again.";
//     } else if (error.response?.data?.message) {
//       errorMessage = error.response.data.message;
//     } else if (error.message) {
//       errorMessage = error.message;
//     }
    
//     dispatch({
//       type: POST_ROSTER_FAILURE,
//       payload: errorMessage,
//     });
    
//     return { 
//       success: false, 
//       error: errorMessage,
//       details: error.response?.data 
//     };
//   }
// };

// // Post new schedule
// export const postSchedule = (scheduleData) => async (dispatch) => {
//   dispatch({ type: POST_SCHEDULE_REQUEST });
//   try {
//     console.log("Posting schedule data:", scheduleData);
    
//     // Format the data as per API requirement
//     const formattedData = Array.isArray(scheduleData) ? scheduleData : [scheduleData];
    
//     const response = await axios.post(
//       `${BASE_URL}/Roster/PostSchedule`,
//       formattedData,
//       {
//         headers: {
//           'Content-Type': 'application/json',
//         }
//       }
//     );
    
//     console.log("Post schedule response:", response.data);
    
//     if (response.data && response.data.statusCode === 200) {
//       dispatch({
//         type: POST_SCHEDULE_SUCCESS,
//         payload: response.data,
//       });
      
//       // Refresh shifts after adding new schedule
//       dispatch(fetchShifts());
      
//       return { 
//         success: true, 
//         data: response.data,
//         message: "Schedule added successfully!" 
//       };
//     } else {
//       throw new Error(response.data?.message || "Failed to add schedule");
//     }
//   } catch (error) {
//     console.error("Error posting schedule:", error);
    
//     dispatch({
//       type: POST_SCHEDULE_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { 
//       success: false, 
//       error: error.response?.data?.message || error.message 
//     };
//   }
// };

// // Fetch roster details
// export const fetchRosterDetails = () => async (dispatch) => {
//   dispatch({ type: FETCH_ROSTER_DETAILS_REQUEST });
//   try {
//     console.log("Fetching roster details...");
//     const response = await axios.get(
//       `${BASE_URL}/Roster/GetRosterdetails`
//     );
    
//     console.log("Roster details response:", response.data);
    
//     let rosterDetails = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       rosterDetails = response.data.resultSet;
//     } else if (Array.isArray(response.data)) {
//       rosterDetails = response.data;
//     }
    
//     console.log("Processed roster details:", rosterDetails.length, "items");
    
//     dispatch({
//       type: FETCH_ROSTER_DETAILS_SUCCESS,
//       payload: rosterDetails,
//     });
    
//     return { success: true, data: rosterDetails };
//   } catch (error) {
//     console.error("Error fetching roster details:", error);
    
//     dispatch({
//       type: FETCH_ROSTER_DETAILS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Fetch all roster details with filters - FIXED VERSION
// export const fetchAllRosterDetails = (filters = {}) => async (dispatch) => {
//   dispatch({ type: FETCH_ALL_ROSTER_DETAILS_REQUEST });
//   try {
//     const { loc = "", sno = "", scode = "", wdate = "" } = filters;
    
//     console.log("Fetching all roster details with filters:", filters);
    
//     const response = await axios.get(
//       `${BASE_URL}/Roster/GetAllRosterDetails?loc=${loc}&sno=${sno}&scode=${scode}&wdate=${wdate}`
//     );
    
//     console.log("All roster details API response:", response.data);
    
//     let allRosterDetails = [];
    
//     if (response.data && response.data.resultSet && Array.isArray(response.data.resultSet)) {
//       // Based on your API response format
//       allRosterDetails = response.data.resultSet.map(item => ({
//         WorkDate: item.wDate || item.WorkDate || item.date || "",
//         Name: item.RName || item.Name || item.name || item.employeeName || "",
//         service_no: item.sNo || item.service_no || item.sno || item.ServiceNo || "",
//         shift_name: item.shiftName || item.shift_name || item.shift || "",
//         shift_code: item.shiftCode || item.shift_code || "",
//         location: item.location || item.LocName || item.locationName || "",
//         // Include original fields for debugging
//         original: item
//       }));
//     } else if (Array.isArray(response.data)) {
//       allRosterDetails = response.data.map(item => ({
//         WorkDate: item.wDate || item.WorkDate || item.date || "",
//         Name: item.RName || item.Name || item.name || item.employeeName || "",
//         service_no: item.sNo || item.service_no || item.sno || item.ServiceNo || "",
//         shift_name: item.shiftName || item.shift_name || item.shift || "",
//         shift_code: item.shiftCode || item.shift_code || "",
//         location: item.location || item.LocName || item.locationName || "",
//       }));
//     } else if (response.data && Array.isArray(response.data)) {
//       allRosterDetails = response.data.map(item => ({
//         WorkDate: item.wDate || item.WorkDate || item.date || "",
//         Name: item.RName || item.Name || item.name || item.employeeName || "",
//         service_no: item.sNo || item.service_no || item.sno || item.ServiceNo || "",
//         shift_name: item.shiftName || item.shift_name || item.shift || "",
//         shift_code: item.shiftCode || item.shift_code || "",
//         location: item.location || item.LocName || item.locationName || "",
//       }));
//     }
    
//     console.log("Processed roster details:", allRosterDetails.length, "items");
//     if (allRosterDetails.length > 0) {
//       console.log("First roster item:", allRosterDetails[0]);
//     }
    
//     dispatch({
//       type: FETCH_ALL_ROSTER_DETAILS_SUCCESS,
//       payload: allRosterDetails,
//     });
    
//     return { success: true, data: allRosterDetails };
//   } catch (error) {
//     console.error("Error fetching all roster details:", error);
    
//     dispatch({
//       type: FETCH_ALL_ROSTER_DETAILS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
    
//     return { success: false, error: error.response?.data?.message || error.message };
//   }
// };

// // Clear selected employees
// export const clearSelectedEmployees = () => ({
//   type: "CLEAR_SELECTED_EMPLOYEES",
// });

// // Set selected dates
// export const setSelectedDates = (dates) => ({
//   type: "SET_SELECTED_DATES",
//   payload: dates,
// });

// // Set selected shifts
// export const setSelectedShifts = (shifts) => ({
//   type: "SET_SELECTED_SHIFTS",
//   payload: shifts,
// });

// // Set selected location
// export const setSelectedLocation = (location) => ({
//   type: "SET_SELECTED_LOCATION",
//   payload: location,
// });

// // Clear all roster state
// export const clearRosterState = () => ({
//   type: "CLEAR_ROSTER_STATE",
// });

// // Reset posting state
// export const resetPostRosterState = () => ({
//   type: "RESET_POST_ROSTER_STATE",
// });

// // Test API connectivity
// export const testAPIConnectivity = () => async () => {
//   try {
//     console.log("Testing API connectivity...");
    
//     // Test locations API
//     const locationsRes = await axios.get(`${BASE_URL}/UserDetails/Locations`);
//     console.log("Locations API test:", locationsRes.status, locationsRes.data);
    
//     // Test shifts API
//     const shiftsRes = await axios.get(`${BASE_URL}/Roster/GetSheduledetails`);
//     console.log("Shifts API test:", shiftsRes.status, shiftsRes.data);
    
//     // Test roster details API
//     const rosterRes = await axios.get(`${BASE_URL}/Roster/GetAllRosterDetails`);
//     console.log("Roster API test:", rosterRes.status, rosterRes.data);
    
//     return {
//       success: true,
//       locations: locationsRes.status === 200,
//       shifts: shiftsRes.status === 200,
//       roster: rosterRes.status === 200,
//       message: "All API endpoints are accessible!"
//     };
//   } catch (error) {
//     console.error("API connectivity test failed:", error);
//     return {
//       success: false,
//       error: error.message,
//       message: "API connectivity test failed. Check console for details."
//     };
//   }
// };

import * as ActionTypes from "./actionTypes";
import RosterManagementService from "../service/RosterManagementService";

// Action Creators using the service

export const fetchLocations = () => async (dispatch) => {
  dispatch({ type: ActionTypes.FETCH_LOCATIONS_REQUEST });
  
  const result = await RosterManagementService.fetchLocations();
  
  if (result.success) {
    dispatch({
      type: ActionTypes.FETCH_LOCATIONS_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: ActionTypes.FETCH_LOCATIONS_FAILURE,
      payload: result.error,
    });
  }
  
  return result;
};

export const fetchEmployeesByLocation = (locationCode) => async (dispatch) => {
  dispatch({ type: ActionTypes.FETCH_EMPLOYEES_BY_LOCATION_REQUEST });
  
  const result = await RosterManagementService.fetchEmployeesByLocation(locationCode);
  
  if (result.success) {
    dispatch({
      type: ActionTypes.FETCH_EMPLOYEES_BY_LOCATION_SUCCESS,
      payload: {
        locationCode,
        employees: result.data,
      },
    });
  } else {
    dispatch({
      type: ActionTypes.FETCH_EMPLOYEES_BY_LOCATION_FAILURE,
      payload: result.error,
    });
  }
  
  return result;
};

export const fetchShifts = () => async (dispatch) => {
  dispatch({ type: ActionTypes.FETCH_SHIFTS_REQUEST });
  
  const result = await RosterManagementService.fetchShifts();
  
  if (result.success) {
    dispatch({
      type: ActionTypes.FETCH_SHIFTS_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: ActionTypes.FETCH_SHIFTS_FAILURE,
      payload: result.error,
    });
  }
  
  return result;
};

export const postRoster = (rosterData) => async (dispatch) => {
  dispatch({ type: ActionTypes.POST_ROSTER_REQUEST });
  
  const result = await RosterManagementService.assignRoster(rosterData);
  
  if (result.success) {
    dispatch({
      type: ActionTypes.POST_ROSTER_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: ActionTypes.POST_ROSTER_FAILURE,
      payload: result.error,
    });
  }
  
  return result;
};

export const postSchedule = (scheduleData) => async (dispatch) => {
  dispatch({ type: ActionTypes.POST_SCHEDULE_REQUEST });
  
  const result = await RosterManagementService.addShift(scheduleData);
  
  if (result.success) {
    dispatch({
      type: ActionTypes.POST_SCHEDULE_SUCCESS,
      payload: result.data,
    });
    
    // Refresh shifts after adding new schedule
    dispatch(fetchShifts());
  } else {
    dispatch({
      type: ActionTypes.POST_SCHEDULE_FAILURE,
      payload: result.error,
    });
  }
  
  return result;
};

export const fetchRosterDetails = () => async (dispatch) => {
  dispatch({ type: ActionTypes.FETCH_ROSTER_DETAILS_REQUEST });
  
  const result = await RosterManagementService.fetchRosterDetails();
  
  if (result.success) {
    dispatch({
      type: ActionTypes.FETCH_ROSTER_DETAILS_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: ActionTypes.FETCH_ROSTER_DETAILS_FAILURE,
      payload: result.error,
    });
  }
  
  return result;
};

export const fetchAllRosterDetails = (filters = {}) => async (dispatch) => {
  dispatch({ type: ActionTypes.FETCH_ALL_ROSTER_DETAILS_REQUEST });
  
  const result = await RosterManagementService.fetchAllRosterDetails(filters);
  
  if (result.success) {
    dispatch({
      type: ActionTypes.FETCH_ALL_ROSTER_DETAILS_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: ActionTypes.FETCH_ALL_ROSTER_DETAILS_FAILURE,
      payload: result.error,
    });
  }
  
  return result;
};

export const testAPIConnectivity = () => async () => {
  return await RosterManagementService.testAPIConnectivity();
};

// UI state actions
export const clearSelectedEmployees = () => ({
  type: ActionTypes.CLEAR_SELECTED_EMPLOYEES,
});

export const setSelectedDates = (dates) => ({
  type: ActionTypes.SET_SELECTED_DATES,
  payload: dates,
});

export const setSelectedShifts = (shifts) => ({
  type: ActionTypes.SET_SELECTED_SHIFTS,
  payload: shifts,
});

export const setSelectedLocation = (location) => ({
  type: ActionTypes.SET_SELECTED_LOCATION,
  payload: location,
});

export const clearRosterState = () => ({
  type: ActionTypes.CLEAR_ROSTER_STATE,
});

export const resetPostRosterState = () => ({
  type: ActionTypes.RESET_POST_ROSTER_STATE,
});